<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <abnormal-bet-report-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import AbnormalBetReportTable from './AbnormalBetReportTable.vue'

  export default {
    name: 'high-abnormal-bet-report',
    components: {AbnormalBetReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/risk/game/AbnormalBetReport.vue